/**
 * Omit keys from an object.
 *
 * @example
 * omit({ name: 'Frank', age: '12' }, 'age') // { name: 'Frank' }
 * omit({ name: 'Frank', age: '12' }, 'name', 'age') // { }
 * @param obj - The object to omit the keys from
 * @param keys - The keys to omit from the object
 * @returns All the keys omitted from the object
 */
export function omit<TObject extends Record<string, unknown>, TKeys extends ReadonlyArray<keyof TObject>>(
    obj: TObject,
    ...keys: TKeys
): Omit<TObject, TKeys[number]> {
    const newObj: Partial<Omit<TObject, TKeys[number]>> = {};
    const keysToInclude = Object.keys(obj).filter(key => !keys.includes(key as keyof TObject));
    for (const key of keysToInclude) {
        (newObj as any)[key] = obj[key];
    }
    return newObj as Omit<TObject, TKeys[number]>;
}
